export default "__VITE_ASSET__61721025__"